<template>
    <div class="bg-neutral-100 dark:bg-neutral-800 rounded my-4 flex items-center justify-between cursor-pointer"
         @click="handleLogEdit">
        <div class="flex items-center p-3">
            <div>
                {{ resource.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ResourceListItem',
  computed: {
    log() {
      return this.resource;
    },
  },
  methods: {
    handleLogEdit() {
      this.$router.push(`/log/${this.log.uuid}/edit`);
    },
  },
  props: {
    resource: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">

</style>
